// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KDve0DZsSs3mC_B4b90r{margin-top:24px}.Bnt5zolZFaog0XWFV9Sv{height:auto}.R_YYUc18YImKhgmtEM2d{background:var(--background-primary-inverted-primary);position:-webkit-sticky;position:sticky;bottom:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"useCaseDesc": `KDve0DZsSs3mC_B4b90r`,
	"customDropdown": `Bnt5zolZFaog0XWFV9Sv`,
	"stickyActions": `R_YYUc18YImKhgmtEM2d`
};
export default ___CSS_LOADER_EXPORT___;
